import React from "react";
import { useSearchParams } from "react-router-dom";
import { CircularProgress, Typography } from "@mui/material";
import fetchStaticHtml from "../../utils/fetchStaticHtml";

const HtmlDocumentViewer = () => {
  const [params] = useSearchParams();
  const fileUrl = params.get("url") || "";
  const [html, setHtml] = React.useState("");
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    if (!fileUrl) {
      setError(true);
      return undefined;
    }

    let cancelled = false;
    fetchStaticHtml(fileUrl)
      .then((content) => {
        if (!cancelled) setHtml(content);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });

    return () => {
      cancelled = true;
    };
  }, [fileUrl]);

  if (error) {
    return (
      <Typography sx={{ p: 3, color: "#71717A" }}>
        Не удалось открыть документ
      </Typography>
    );
  }

  if (!html) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: 48 }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <iframe
      title="HTML document"
      srcDoc={html}
      style={{ display: "block", width: "100%", height: "100vh", border: "none" }}
    />
  );
};

export default HtmlDocumentViewer;
